module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Content_Related Widget
(function (fox, $){
	'use strict';

	fox.registerWidget('Pager_Simple', {
		configure: function (options) {
			this.registerOptions('', {
				skipPreloader: true,
				pagesCount: 4,
				'tpl.container': 'pager',
				noScroll: true,
				currentPageClass: 'cp',
				addHrefAttribute: false,
				page: '',
				handleDom: {
					setPage: {
						target: '.pager-click',
						event: 'click'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function() {
			if (!fox.isEmpty(fox.site.member) && this.getOption('logged.tpl.container')) {
				this.setOption('tpl.container', this.getOption('logged.tpl.container'))
					.setOption('pagesCount', this.getOption('logged.pagesCount'));
			}
			
			this.callParent('init', arguments);
		},

		addedToDom: function () {
			var $jDoc, $mainElement, embedWidget;
			
			if (this.getOption('noScroll') !== true) {
				$jDoc = $(document);

				if (!!this.getOption('embed.widget')){
					embedWidget = this.wom1(this.getOption('embed.widget'));
				} else {
					embedWidget = this.getParent();
				}

				try {
					$mainElement = $(embedWidget.element[0]);
				} catch (e) {
					console.log(e);
				}
				
				if ($jDoc.scrollTop() > $jDoc.height() * 0.2) {
					$('body, html').animate({
						scrollTop: $mainElement && $mainElement.offset().top || 0
					}, 500);
				}
			}
		},

		_calculatePagerData: function () {
			this.callParent('_calculatePagerData', arguments);

			if (this.getOption('addHrefAttribute') === true && this.navPrefix) {
				if (fox.Navigator.get('tags')){
					var tagFilter = 'tags=' + fox.Navigator.get('tags');
					this._pagerData.link = [fox.site.page.alias, tagFilter, this.navPrefix].join('/');
				}else{
					this._pagerData.link = [fox.site.page.alias, this.navPrefix].join('/');
				}
			}
		}

	}, 'Grid_Pager');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/publisher/widget/pager/simple.js
// module id = 483
// module chunks = 4